export enum StudentUnitContentExerciseStatus {
  TO_DO = 'to_do',
  TO_REVIEW = 'to_review',
  REJECTED = 'rejected',
  APPROVED = 'approved',
  AI_CHECK = 'ai_check',
  AI_ERROR = 'ai_error'
}
